import * as React from "react";
import "./UpgradeButton.css";
import { DefaultButton, Icon } from "office-ui-fabric-react";
import { PPMFeatures, Subscription } from "../../../store/Tenant";
import { ApplicationState } from "../../../store";
import { connect } from "react-redux";
import { UserState } from "../../../store/User";
import { CommonOperations, contains } from "../../../store/permissions";
import Link from "../../common/Link";

type StateProps = {
    subscription: Subscription;
    user: UserState;
};

type Props = StateProps;

const UpgradeButton = (props: Props) => {
    const { subscription, user } = props;
    const proposeUpgrade = Subscription.contains(subscription, PPMFeatures.UpgradeProposal);
    const hasBillingManage = user.permissions && contains(user.permissions.common, CommonOperations.BillingManage);

    if (!proposeUpgrade || !hasBillingManage || subscription.isTrial) {
        return null;
    }

    return (
        <Link href="https://ppm.express/ppm-express-pricing/" target="_blank">
            <DefaultButton
                className="nav-header-button with-background allow-shrink-title nav-header-upgrate-button"
                text="Upgrade"
                onRenderText={(prs, defaultRender) => (
                    <span className="upgrade-button-text-container">
                        {defaultRender?.(prs)}
                        <Icon iconName="PPMXUpSolid" style={{ marginLeft: 4 }} />
                    </span>
                )}
            />
        </Link>
    );
};

function mapStateToProps(state: ApplicationState): StateProps {
    return {
        subscription: state.tenant.subscription,
        user: state.user,
    };
}

export default connect(mapStateToProps)(UpgradeButton);
